import ErrorMessage from "./ErrorMessage";

function NoAccessPage() {
    return (
        <ErrorMessage
            titleKey="error.noAccess.title"
            messageKey="error.noAccess.message"
            buttonLabelKey="error.contactAdminButton"
            buttonTo="https://mainition.de/#kontakt"
        />
    );
}

export default NoAccessPage;
